module.exports = __webpack_public_path__ + "img/close.0ebf66e0.svg";